<button mat-icon-button class="close-button " mat-dialog-close><span
    class="material-icons">close</span></button>
<h1 mat-dialog-title *ngIf="data.title">{{data.title}}</h1>
<mat-dialog-content class="p--0" >
  <div class="row p--0 m--0">
    <div class="col-12 col-md-6 col-lg-7 text-center text-lg-left p--32">
      <div *ngIf="data.content; else staticContent" class="dialog-content" [innerHTML]="data.content"></div>
      <ng-template #staticContent>
        <div class="static-content">
          <h5 class="mat-text-primary h5" translate>Sblocca il tuo potenziale</h5>
          <h4 translate>Ottieni una visione completa del tuo piano di miglioramento e potenzia il tuo business grazie
            all’Ai.
          </h4>
          <div class="content">
            <p translate>Il piano di miglioramento è riportato nel <b>Benchmark</b>, generato per aiutarti ad ottenere:</p>
            <ul class="list-check">
              <li class="text-strong">{{'Una visione completa del tuo business' | translate}}</li>
              <li class="text-strong">{{'A Scoprire le criticità che ostacolano la tua crescita' | translate}}</li>
              <li class="text-strong">{{'A cogliere nuove opportunità per aumentare i tuoi profitti' | translate}}</li>
            </ul>

            <hr class="mt--16 mb--16" />
            <div class="form-purchase">
              <div class="row pt--24 mx--0 align-items-center gap-16">
                <ng-container *ngIf="data.freeOffer; else normalPrice">
                  <div class="h3 text-strong">Ottieni adesso il tuo Benchmark gratis</div>
                  <div class="promo-wellcome"> Promo BENVENUTO <span class="di di-arrow-right"></span> 0€ invece di <span class="text-striked">{{ data.productPrice | currency }}</span></div>
                </ng-container>
                <ng-template #normalPrice>
                  <div class="h4 text-strong">{{ data.productName | translate}}</div>
                  <div class="h1 text-strong">{{ data.productPrice | currency }}</div>
                  <div class="text-body">{{'Iva esclusa' | translate}}</div>
                </ng-template>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
      <!-- <div class="mat-text-primary lh-1 pt--24">
        Sei interessato ad ottenere uno screening<br />
        Dei tuoi concorrenti? <button mat-button [mat-dialog-close]="'getmorereport'" class="text-trong"
          color="primary">Clicca qui</button>
      </div> -->
    </div>

    <div class="col-12 col-md-6 col-lg-5 hide-sm show-md  p--32 bg-sky text-center flex-column align-items-center " >
      <!-- <div class="bg-benchmark-folder fw fh"[class.bgcenter]="data.freeOffer"> -->
      <img ngSrc="/images/products/copertina-benchmark.webp" width="280" height="400" />
      <ng-container *ngIf="data.freeOffer;else buyActions">
        <button mat-stroked-button color="primary" [downloadAnimation]="downloading$()" (click)="getFreeReport()" class="mt--lg-24">Scarica il Benchmark</button>
      </ng-container>
      <ng-template #buyActions>
          <div class="row flex-nowrap justify-content-center gap-16 px--0 mt--lg-24">
            <button mat-stroked-button color="primary" class="fw" [mat-dialog-close]="'getdemo'">Scarica una esempio</button>
            <button mat-flat-button color="primary" class="fw" [mat-dialog-close]="'confirm'" cdkFocusInitial>Acquista ora</button>
          </div>
      </ng-template>
      <!-- </div> -->
    </div>
  </div>
  <!-- <div class="row mx--0 align-items-center">
   
    <div class="col-12 col-md-6 col-lg-5 pl--32 pr--32 pb--16 bg-sky">
      <div class="row flex-nowrap gap-16 px--0">
            <ng-container *ngIf="data.freeOffer;else buyActions">
              <button mat-flat-button color="primary"  [mat-dialog-close]="'getfreereport'">Scarica il tuo Benchmark</button>
            </ng-container>
            <ng-template #buyActions>
              <button mat-stroked-button color="primary" class="fw" [mat-dialog-close]="'getdemo'">Scarica una esempio</button>
              <button mat-flat-button color="primary" class="fw" [mat-dialog-close]="'confirm'" cdkFocusInitial>Acquista ora</button>
            </ng-template>
        </div>
      </div>
  </div> -->
</mat-dialog-content>